<div class="alert alert-solid-brand alert-bold" role="alert" [hidden]="!infoHide">
	<div class="alert-icon"><i class="flaticon-warning"></i></div>
	<div class="alert-text">
		{{ 'FE.APPROVALS.TABS.WAITINGFORMYAPPROVAL.INFOALERTS.APPROVALORDER' | localize }}
	</div>
	<div class="alert-close">
		<button type="button" class="close" data-dismiss="alert" aria-label="Close" (click)="btnInfoHide()">
			<span aria-hidden="true"><i class="la la-close"></i></span>
		</button>
	</div>
</div>




<div class=" filter_content">
	<div class="form-group kt-form__group row">
		<div class="col-md-3 kt-margin-b-10-tablet-and-mobile">
			<mat-select class="form-control" placeholder="Gün Sayısı" [(ngModel)]="selectedLastNumberDayObj">
				<mat-option *ngFor="let approvalDateFilter of approvalDateFilters"
							[value]="approvalDateFilter"
							(click)="onSelectedNumberOfDays(approvalDateFilter.value)">
					{{approvalDateFilter.key}}
				</mat-option>
			</mat-select>
		</div>
		<!--Onay bekleyen taleplerim ve Geçmiş Talepleim sayfasında olacak sadece-->
		<div class="col-md-3 kt-margin-b-10-tablet-and-mobile">
			<div class="form-group ">
				<div class="kt-input-icon kt-input-icon--left">
					
						<input type="text" class="form-control" placeholder="Onay bekleyen talep içinde arama yapın" #searchInput [(ngModel)]="searchKeyword" name="searchKeyword">
					<span class="kt-input-icon__icon kt-input-icon__icon--left">
						<span><i class="la la-search"></i></span>
					</span>
				</div>
			</div>
		</div>
		<!-- START BUTTON TOOLBAR -->
		<div class="col-md-6" [hidden]="(filteredProductList | async).length < 1">
			<div class="pull-right">
				<button type="button" class="btn btn-success kt-margin-r-10" (click)="btnSelectedApproveOrRejected(1)">
					{{ 'FE.APPROVALS.BUTTONS.APPLYSELECTED' | localize }}

				</button>
				<button type="button" class="btn btn-danger kt-margin-r-10" (click)="btnSelectedApproveOrRejected(0)">{{ 'FE.APPROVALS.BUTTONS.REJECTSELECTED' | localize }}</button>
				

				<!-- Excel Export Buttons -->
				<div ngbDropdown [placement]="'bottom-right'" class="dropdown dropdown-inline">
					<a ngbDropdownToggle href="javascript:;" class="btn btn-success kt-subheader__btn-options">
						{{ 'FE.APPROVALS.TABS.PASTORDERS.BUTTON.EXCEL' | localize }} &nbsp; <i class="la la-angle-down"></i>
					</a>
					<div ngbDropdownMenu class="dropdown-menu dropdown-menu-right">
						<a class="dropdown-item" href="javascript:;" (click)="btnExportToExcel(true)"><i class="la la-file-image-o"></i> {{ 'FE.APPROVALS.TABS.PASTORDERS.BUTTON.EXCEL.DOWNLOADWITHPHOTO' | localize }}</a>
						<div class="dropdown-divider"></div>
						<a class="dropdown-item" href="javascript:;" (click)="btnExportToExcel(false)"><i class="la la-file-text"></i>{{ 'FE.APPROVALS.TABS.PASTORDERS.BUTTON.EXCEL.DOWNLOADWITHOUTPHOTO' | localize }}</a>
					</div>
				</div>
			
			</div>
		</div>
		<!-- END BUTTON TOOLBAR -->
	</div>
</div>

<ng-container *ngIf="!(isLoadingComponent | async)">

	<div [hidden]="(filteredProductList | async).length < 1">
		<div class="kt-widget5" style="margin-right:0rem;">
			<div class="kt-widget5__item ng-star-inserted">
				<div class="kt-widget5__content checkbox_content">
					<label class="kt-checkbox kt-checkbox--primary">
						<input type="checkbox" #selectProducts (click)="checkboxSelectAll(selectProducts)"> {{ 'FE.APPROVALS.CHECKBOXS.SELECTALL' | localize }}
						<span></span>
					</label>
				</div>
				<div class="kt-widget5__content">
					<div class="kt-widget5__stats">
						<span class="kt-widget5__sales text-center">
							{{ 'FE.APPROVALS.GRID.TOTALDECI' | localize }}  : <strong>{{sumDeci | async}}</strong>
						</span>
					</div>
				</div>
			</div>
		</div>
		
		<div *ngFor="let product of (filteredProductList | async); let i = index" class="col-12 pList">
			<!--ngStyle ile eğer talep eden talebini iptal etmiş ise ngStyle ileekrana tıklamasını engelliyoruz-->
			<div class="kt-widget kt-widget--user-profile-3 pRow border-bottom kt-padding-t-10 kt-padding-b-10" #pOrderRow [ngStyle]="{'pointer-events': product.isCanceledOrder ? 'none' : 'block'}">
				<!-- <div class="w-100 edit-col mb-2">
					<label *ngIf="!product.isCanceledOrder" class="kt-checkbox kt-checkbox--primary pChckbx" placement="top" ngbTooltip="Seç" ngbTooltipClass="kt-tooltip">
						<input type="checkbox" [(ngModel)]="product.isChecked" name="checkboxName">
						<span></span>
					</label>
				</div> -->
				<div class="kt-widget__top d-block">
					<div class="row">
						<div class="col-sm-2 edit-col">
							<label *ngIf="!product.isCanceledOrder" class="kt-checkbox kt-checkbox--primary pChckbx" placement="top" ngbTooltip="Seç" ngbTooltipClass="kt-tooltip">
								<input type="checkbox" [(ngModel)]="product.isChecked" name="checkboxName">
								<span></span>
							</label>
							<div class="kt-widget__media kt-hidden- mt-n3">
								<img (click)="openImage(product.productCode,product.productName)" photoUrl class="kt-widget7__img w-75" [attr.src]="getPhotoUrl(product.productCode)" alt="">
						</div>
						</div>
						<div class="col-md-6 pl-0">
							<div class="kt-widget__content pl-0">
								<div class="kt-widget__head">
									<span style="display:none" class="orderDetailsId">{{product.orderDetailsId}}</span>
									<span style="display:none" class="twinOrderDetailsId">{{product.twinOrderDetailsId}}</span>
									<span style="display:none" class="orderApprovalTaskId">{{product.orderApprovalTaskId}}</span>
									<span style="display:none" class="twinOrderApprovalTaskId">{{product.twinOrderApprovalTaskId}}</span>
									<span style="display:none" class="productId">{{product.productId}}</span>
									<span style="display:none" class="variationId">{{product.variationId}}</span>
									<a class="kt-widget__username m-0">
										{{product.productName}}
									</a>
								</div>
								<div class="kt-widget__info">
									<div class="kt-widget__desc pr-0">
										<div class="kt-widget__subhead">
											<a class="text-primary pr-4"><i class="flaticon-layers"></i>{{product.productBusinessUnitName}}</a>
											<a class="text-primary pr-4"><i class="flaticon2-tag"></i>{{product.productBrand}}</a>
											<a class="text-danger pr-4"><i class="flaticon-time-1"></i>{{product.productDeci}}{{ 'FE.APPROVALS.GRID.DECI' | localize }}</a>
											<a href="javascript:void(0);" class="text-danger pr-4" *ngIf="!product.hasOrderSpecialCodeStockViewAuth"><i placement="top" ngbTooltip="{{ 'FE.APPROVALS.TABS.WAITINGFORMYAPPROVAL.ICONS.TOOLTIP.SPECIALCODESTOCKVIEW' | localize }}" ngbTooltipClass="kt-tooltip" class="la la-eye-slash la-lg"></i></a>
											<a href="javascript:void(0);" class="text-danger pr-0" *ngIf="!product.hasOrderStockViewAuth"><i placement="top" ngbTooltip="{{ 'FE.APPROVALS.TABS.WAITINGFORMYAPPROVAL.ICONS.TOOLTIP.STOCKVIEW' | localize }}" ngbTooltipClass="kt-tooltip" class="la la-level-up la-lg"></i></a>
										</div>
										<span class="kt-font-bolder h5"><span class="text-success kt-font-boldest"># </span>{{product.productCode}}</span><br>
										<span class="text-success kt-font-boldest" *ngIf="product.productWmsTypeName">{{product.productWmsTypeName ? product.productWmsTypeName : ''}}</span>
										<span *ngIf="product.productWmsTypeName"> / </span>
										<div *ngIf="product.variationId > 0">
										<span *ngIf="product.expirationDate"><strong>{{ 'FE.APPROVALS.GRID.EXPIRATIONDATE' | localize }} :</strong>{{product.expirationDate}} </span>
										<span *ngIf="product.expirationDate && product.lot"> - </span>
										<span *ngIf="product.lot"><strong>{{ 'FE.APPROVALS.GRID.LOT' | localize }} :</strong>{{product.lot}} </span>
										<span *ngIf="product.lot && product.barcode"> - </span>
										<span *ngIf="product.barcode"><strong>{{ 'FE.APPROVALS.GRID.BARCODE' | localize }} :</strong>{{product.barcode}}</span>
										</div><br />
										<span *ngIf="product.orderComment"><i class="fa fa-comment"></i> {{product.orderComment}}</span>
									</div>	
								</div>
							</div>
						</div>
						<div class="col-md-4">
							<div class="row">
								<div class="col-md-12">
									<div class="row">
										<div class="col-md-4">
											<button type="button" class="btn btn-success btn-sm kt-margin-b-10 btnApprove w-100"  placement="top" ngbTooltip="{{ 'FE.APPROVALS.TABS.WAITINGFORMYAPPROVAL.BUTTONS.APPROVE' | localize }}" (click)="btnApprovalOrRejectForAProject(1,product,pOrderRow)" ngbTooltipClass="kt-tooltip">Onayla</button>
										</div>
										<div class="col-md-4">
											<button type="button" class="btn btn-danger btn-sm kt-margin-b-10 btnDelete w-100"  placement="top" ngbTooltip="{{ 'FE.APPROVALS.TABS.WAITINGFORMYAPPROVAL.BUTTONS.REJECT' | localize }}" ngbTooltipClass="kt-tooltip" (click)="btnApprovalOrRejectForAProject(0, product,pOrderRow)">Reddet</button>
										</div>
										<div class="col-md-4">
											<button type="button" class="btn btn-primary btn-sm kt-margin-b-10 w-100" (click)="onClickBtnProductHistory(product)" *ngIf="(isProductHistoryView | async)">{{ 'FE.APPROVALS.GRID.ORDERHISTORY' | localize }}</button>								
										</div>
									</div>
								</div>
								<div class="col-md-12">
									<div class="kt-widget__info">
										<div class="row">
											<div class="col-md-6">
												<div class="kt-widget__item">
													<div class="livestock text-center">
														<span class="kt-widget5__sales w-100 d-block mb-2" *ngIf="isStokViewAuth">{{ 'FE.APPROVALS.GRID.COLUMN.STOCK' | localize }}</span>
														<span class="kt-widget5__number" *ngIf="isStokViewAuth"><strong>{{product.instantProductStock}}</strong></span>
													</div>
												</div>
											</div>
											<div class="col-md-6">
												<div class="kt-widget__item">
													<div class="stock">
														<span class="kt-widget5__sales w-100">{{ 'FE.APPROVALS.GRID.COLUMN.ORDEREDQTY' | localize }}</span>
														<input class="form-control form-control-sm orderAmount" type="number" value="{{product.qty}}" #orderAmount (click)="onClickOrderAmount(orderAmount)" (change)="onChangeOrderAmount(orderAmount)" placeholder="{{ 'FE.APPROVALS.GRID.COLUMN.PLACEHOLDERS.ORDEREDQTY' | localize }}">
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<!-- <div class="kt-widget__content">
						<div class="kt-widget__head">
							<span style="display:none" class="orderDetailsId">{{product.orderDetailsId}}</span>
							<span style="display:none" class="twinOrderDetailsId">{{product.twinOrderDetailsId}}</span>
							<span style="display:none" class="orderApprovalTaskId">{{product.orderApprovalTaskId}}</span>
							<span style="display:none" class="twinOrderApprovalTaskId">{{product.twinOrderApprovalTaskId}}</span>
							<span style="display:none" class="productId">{{product.productId}}</span>
							<span style="display:none" class="variationId">{{product.variationId}}</span>
							<a class="kt-widget__username m-0">
								{{product.productName}}
							</a>
							<div class="kt-widget__action">
								<button type="button" class="btn btn-success btn-sm kt-margin-r-10 kt-margin-b-10 btnApprove">Onayla</button>
								<button type="button" class="btn btn-danger btn-sm kt-margin-b-10 kt-margin-r-10 btnDelete">Reddet</button>
								<button type="button" class="btn btn-primary btn-sm kt-margin-b-10" (click)="onClickBtnProductHistory(product)" *ngIf="(isProductHistoryView | async)">{{ 'FE.APPROVALS.GRID.ORDERHISTORY' | localize }}</button>								
							</div>
						</div>
						<div class="kt-widget__info">
							<div class="kt-widget__desc">
						<div class="kt-widget__subhead">
							<a class="text-primary"><i class="flaticon-layers"></i>{{product.productBusinessUnitName}}</a>
							<a class="text-primary"><i class="flaticon2-tag"></i>{{product.productBrand}}</a>
							<a class="text-danger"><i class="flaticon-time-1"></i>{{product.productDeci}}{{ 'FE.APPROVALS.GRID.DECI' | localize }}</a>
							<a href="javascript:void(0);" class="text-danger" *ngIf="!product.hasOrderSpecialCodeStockViewAuth"><i placement="top" ngbTooltip="{{ 'FE.APPROVALS.TABS.WAITINGFORMYAPPROVAL.ICONS.TOOLTIP.SPECIALCODESTOCKVIEW' | localize }}" ngbTooltipClass="kt-tooltip" class="la la-eye-slash la-lg"></i></a>
							<a href="javascript:void(0);" class="text-danger" *ngIf="!product.hasOrderStockViewAuth"><i placement="top" ngbTooltip="{{ 'FE.APPROVALS.TABS.WAITINGFORMYAPPROVAL.ICONS.TOOLTIP.STOCKVIEW' | localize }}" ngbTooltipClass="kt-tooltip" class="la la-level-up la-lg"></i></a>
						</div>
							<span class="kt-font-bolder h5"><span class="text-success kt-font-boldest"># </span>{{product.productCode}}</span><br>
							<span class="text-success kt-font-boldest" *ngIf="product.productWmsTypeName">{{product.productWmsTypeName ? product.productWmsTypeName : ''}}</span>
							<span *ngIf="product.productWmsTypeName"> / </span>
							<div *ngIf="product.variationId > 0">
							<span *ngIf="product.expirationDate"><strong>{{ 'FE.APPROVALS.GRID.EXPIRATIONDATE' | localize }} :</strong>{{product.expirationDate}} </span>
							<span *ngIf="product.expirationDate && product.lot"> - </span>
							<span *ngIf="product.lot"><strong>{{ 'FE.APPROVALS.GRID.LOT' | localize }} :</strong>{{product.lot}} </span>
							<span *ngIf="product.lot && product.barcode"> - </span>
							<span *ngIf="product.barcode"><strong>{{ 'FE.APPROVALS.GRID.BARCODE' | localize }} :</strong>{{product.barcode}}</span>
							</div><br />
							<span *ngIf="product.orderComment"><i class="fa fa-comment"></i> {{product.orderComment}}</span>
						</div>	
							<div class="kt-widget__item pull-right kt-margin-r-20">
								<div class="livestock text-center">
									<span class="kt-widget5__sales" *ngIf="isStokViewAuth">{{ 'FE.APPROVALS.GRID.COLUMN.STOCK' | localize }}</span><br>
									<span class="kt-widget5__number kt-margin-t-10" *ngIf="isStokViewAuth"><strong>{{product.instantProductStock}}</strong></span>
								</div>
							</div>
							<div class="kt-widget__item pull-right kt-margin-r-40-tablet-and-mobile">
								<div class="stock">
									<span class="kt-widget5__sales">{{ 'FE.APPROVALS.GRID.COLUMN.ORDEREDQTY' | localize }}</span><br>
									<input class="form-control form-control-sm orderAmount" type="number" value="{{product.qty}}" #orderAmount (click)="onClickOrderAmount(orderAmount)" (change)="onChangeOrderAmount(orderAmount)" placeholder="{{ 'FE.APPROVALS.GRID.COLUMN.PLACEHOLDERS.ORDEREDQTY' | localize }}">
								</div>
							</div>
						</div>
					</div> -->
				</div>
				<div class="kt-widget__bottom border-light">
					<div class="kt-widget__item">
						<div class="kt-widget__icon">
							<i class="flaticon-clock-2"></i>
						</div>
						<div class="kt-widget__details">
							<span class="kt-widget__title">{{ 'FE.APPROVALS.GRID.COLUMN.DATE' | localize }}</span>
							<span class="kt-widget__value kt-font-14">{{product.orderDate}}</span>
						</div>
					</div>
					<div class="kt-widget__item">
						<div class="kt-widget__icon">
							<i class="flaticon-user-ok"></i>
						</div>
						<div class="kt-widget__details">
							<span class="kt-widget__title">Talep Eden</span>
							<span class="kt-widget__value userName kt-font-14">{{product.ordererName}}</span>
						</div>
					</div>
					<div class="kt-widget__item">
						<div class="kt-widget__icon">
							<i class="flaticon-buildings"></i>
						</div>
						<div class="kt-widget__details">
							<span class="kt-widget__title">{{ 'FE.APPROVALS.GRID.COLUMN.SOURCEADDRESS' | localize }}</span>
							<span class="kt-widget__value kt-font-14">{{product.sourceAddressName}}</span>
						</div>
					</div>
					<div class="kt-widget__item">
						<div class="kt-widget__icon">
							<i class="flaticon-paper-plane"></i>
						</div>
						<div class="kt-widget__details">
							<span class="kt-widget__title">{{ 'FE.APPROVALS.GRID.COLUMN.DESTINATIONADDRESS' | localize }}</span>
							<span class="kt-widget__value kt-font-14">{{product.toAddressName}}</span>
						</div>
					</div>
				</div>
				<!--Talep ve stock uyarısı-->
				<div class="col-md-12 text-center isCanceled" *ngIf="product.isCanceledOrder">
					<h4 class="text-danger kt-margin-t-10 ">
						{{product.approvalStatusText}}
						<i class="la la-info-circle fa-lg text-danger"
							placement="top"
							ngbTooltip="{{product.approvalStatusDescText}}"
							ngbTooltipClass="kt-tooltip">
						</i>
					</h4>
					
				</div>

				<div class="col-md-12 text-center approveResult" style="display: none;">
					<h4 class="text-success"></h4>

				</div>
				<div class="col-md-12 text-right approve_P" style="display: none;">
					<div class="kt-widget5__info">
						<h5 class="text-danger"></h5>

					</div>
				</div>
				<!--Talep ve stok uyarısı-->
			</div>
		</div>
	</div>

	<div *ngIf="(filteredProductList | async).length < 1">
		<h5 class="text-center">{{ 'FE.INFOMESSAGE.ORDERAPPROVAL.NOTFOUNDWAITINGFORMYAPPROVAL' | localize }}</h5>
	</div>



</ng-container>

<div *ngIf="(isLoadingComponent | async)" class="row">
	<div class="col-md-12">
		<div class="center pl-4">
			<!-- Yukleniyor... -->
				<mat-spinner [diameter]="30"></mat-spinner>
		</div>
	</div>
</div>

